import { Component, ComponentInterface, JSX, h } from '@stencil/core';

@Component({
  tag: 'nbn-faq',
  styleUrl: 'nbn-faq.scss',
  scoped: true
})
export class NbnFaq implements ComponentInterface {
  public render(): JSX.Element {
    return (
      <div>
        <div class={'faq_wrapper'} id="faq_wrapper">
          <dls-h2 class="faq_wrapper_title">
            <span class="faq_wrapper_title_text">Frequently asked questions</span>
          </dls-h2>
          <dls-h3 class="faq_wrapper_title2">
            <span class="faq_wrapper_title2_text">Fibre Upgrade</span>
          </dls-h3>
          <agl-ds-accordion accordionLabel="What is a fibre upgrade?">
            <div class="text aem-GridColumn aem-GridColumn--default--12" slot="panel-content">
              <div class="cmp-text">
                <p>
                  nbn co is currently rolling out a program in selected areas across Australia so that more customers get access to full
                  fibre.
                </p>
                <p>
                  This means addresses connected to the <b>nbn</b> network via Fibre to the Node (FTTN) or Fibre to the Curb (FTTC), may be
                  eligible to upgrade their connection type to full fibre, also known as Fibre to the Premise (FTTP).
                </p>
                <p>
                  Upgrading to FTTP will give you access to a more reliable network and higher speed plans, which means you can do more
                  online with less interruptions, including:
                  <br />
                </p>
                <ul>
                  <li>have multiple people online at the same time</li>
                  <li>work from home and make video calls</li>
                  <li>stream high-definition video (4K)</li>
                  <li>play online games</li>
                </ul>
                <p>
                  <br />
                  <b>Are you eligible for a fibre upgrade?</b>
                  <br />
                </p>
                <p>To check your eligibility simply enter your address at the top of the page. </p>
                <p>If you’re eligible, we’ll automatically let you know your connection type and if a fibre upgrade is available.</p>
                <p>
                  <b>Fibre upgrade installation process</b>
                </p>
                <p>
                  If you order a plan with a fibre upgrade, we’ll arrange an appointment with an <b>nbn</b> technician so they can start the
                  installation process.
                </p>
                <p>Your first appointment usually takes place within 7 days of your order.</p>
                <p>
                  You’ll receive an SMS within an hour of your order with all the details of your first appointment and how to reschedule
                  it. If you miss an appointment, you may incur a fee.
                </p>
                <p>Someone over the age of 18 will need to be home at the time.</p>
                <p>
                  Learn more about the{' '}
                  <a href="/content/dam/digital/agl/documents/help-and-support/agl-nbn-fttp-installation-guide-2024.pdf">
                    <u>installation process.</u>
                  </a>
                </p>
              </div>
            </div>
          </agl-ds-accordion>
          <agl-ds-accordion accordionLabel="Is a fibre upgrade really free?">
            <div class="text aem-GridColumn aem-GridColumn--default--12" slot="panel-content">
              <div class="cmp-text">
                <p>NBN Co may choose to charge a $220 cancellation/downgrade fee if:</p>
                <ul>
                  <li>you downgrade to a plan with speeds below our Home Fast plan within 12 months.</li>
                  <li>
                    you cancel your <b>nbn </b>connection within 12 months including, for example, moving house.
                  </li>
                </ul>
                <p>
                  Learn more in schedule 2 of our{' '}
                  <a
                    href="/content/dam/digital/agl/documents/terms-and-conditions/telecommunications/agl-telecommunications-customer-terms-072024.pdf"
                    target="_blank"
                  >
                    <u>customer terms.</u>
                  </a>
                </p>
              </div>
            </div>
          </agl-ds-accordion>
        </div>
      </div>
    );
  }
}
